import { Check } from "lucide-react";
import { savingsPct } from "@/components/PlanToggle";

export const PRO_PERKS = ["Unlimited worlds and works", "Invite co-writers with roles, reviews, comments and @mentions", "Every theme, plus your own custom themes", "All scene break designs in the writing desk", "Everything in Free"];

export const PerkList = ({ perks, testId }) => (
  <ul className="space-y-2" data-testid={testId}>
    {perks.map((p) => <li key={p} className="flex gap-2 text-sm text-slate-300"><Check className="w-4 h-4 text-amber-400 shrink-0 mt-0.5" />{p}</li>)}
  </ul>
);

export const fmtDate = (iso) => new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });

export const PriceBlock = ({ interval, prices, promo }) => {
  const { month, year } = prices;
  const price = interval === "year" ? year : month;
  const has = promo && promo.interval === interval;
  return (
    <div key={`${interval}-${has ? promo.code : ""}`} className="animate-in fade-in slide-in-from-bottom-1 duration-300 space-y-2" data-testid="pro-price-block">
      <p className="flex flex-wrap items-center gap-3">
        <span>
          {has && <span className="font-display text-2xl text-slate-500 line-through mr-2" data-testid="pro-price-original">${price}</span>}
          <span className="font-display text-5xl text-amber-50" data-testid="pro-price">${has ? promo.discounted.toFixed(2) : price}</span>
          <span className="text-slate-400"> {has ? `first ${interval}` : `/ ${interval}`}</span>
        </span>
        {interval === "year" && (
          <span className="rounded-full border border-amber-500/40 bg-amber-500/10 px-2.5 py-0.5 text-[11px] font-code text-amber-300" data-testid="yearly-savings-badge">
            Save {savingsPct(month, year)}% vs monthly
          </span>
        )}
      </p>
      {has ? (
        <p className="text-xs text-emerald-300/80" data-testid="promo-applied-note">Code {promo.code} applied. Then ${price}/{interval} after that.</p>
      ) : interval === "year" && (
        <p className="text-xs text-slate-500" data-testid="yearly-per-month-note">That's about ${(year / 12).toFixed(2)}/month, billed yearly.</p>
      )}
    </div>
  );
};
